import React from 'react';

import PageWrapper from "./shared/pagewrapper/PageWrapper";

import FormConsultaCodigoValidacao from "./FormConsultaCodigoValidacao";
import Title from "./Title";

import {makeStyles} from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    textTypograph: {
        textAlign: 'center'
    }
}));
export default function PageHome() {
    const classes = useStyles();

    return (
        <PageWrapper>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Title />
                    <Typography
                        className={classes.textTypograph}>
                        Consulta exclusiva para diplomas emitidos a partir de 01/01/2022 conforme Portaria MEC Nº 554 DE 11 de março 2019.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <FormConsultaCodigoValidacao />
                </Grid>
            </Grid>
        </PageWrapper>
    );
};